import { useState } from "react";
import CompanyAdminSidebar from "../components/Sidebar/CompanyAdminSidebar";
import SidebarLayoutHeader from "../components/SidebarLayout/SidebarLayoutHeader";
import SidebarLayoutFooter from "../components/SidebarLayout/SidebarLayoutFooter";
import ThemeToggle from "../components/ThemeToggle";

export default function CompanyAdminLayout({ children }) {
  const [isCollapsed, setIsCollapsed] = useState(
    () => typeof window !== "undefined" && window.innerWidth < 1024,
  );

  return (
    <div className="min-h-screen">
      <SidebarLayoutHeader
        onMenuClick={() => setIsCollapsed((v) => !v)}
        isDrawerOpen={!isCollapsed}
      />
      <CompanyAdminSidebar
        isCollapsed={isCollapsed}
        onClose={() => setIsCollapsed(true)}
      />

      <div
        className={`${isCollapsed ? "lg:ml-16" : "lg:ml-60"} pt-16 sm:pt-19 flex flex-col min-h-screen transition-[margin] duration-300 ease-in-out`}
      >
        <main className="flex-1 flex flex-col pb-20 lg:pb-0">{children}</main>

        {/* Theme toggle - visible on all screens */}
        <div className="fixed bottom-6 right-6 z-40">
          <ThemeToggle />
        </div>

        <SidebarLayoutFooter />
      </div>
    </div>
  );
}
